import * as yup from "yup";
import { LOCALE } from "../../properties/Locale";

export const UserValidator = yup.object().shape({
  username: yup.string().required(LOCALE.usernameRequired),
  firstName: yup.string().required(LOCALE.firstnameRequired),
  lastName: yup.string().required(LOCALE.surnameRequired),
  email: yup
    .string()
    .email(LOCALE.enterValidEmail)
    .required(LOCALE.emailRequired),
  phoneNumber: yup.string().required(LOCALE.phoneNumberRequired),
  selectedRoles: yup
    .array()
    .min(1, LOCALE.minOneRoleRequired)
    .required(LOCALE.rolesRequired),
});
